import { render, staticRenderFns } from "./MeuPainelComprasPendenteIntegracao.vue?vue&type=template&id=e1720036&scoped=true&"
import script from "./MeuPainelComprasPendenteIntegracao.vue?vue&type=script&lang=js&"
export * from "./MeuPainelComprasPendenteIntegracao.vue?vue&type=script&lang=js&"
import style0 from "./MeuPainelComprasPendenteIntegracao.vue?vue&type=style&index=0&id=e1720036&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1720036",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VDivider,VList,VListItem,VListItemContent,VRow})
